import * as React from 'react';
import s from '../solution-page-views/solution-info/solution-info.scss';
import { PreviewMode } from '../preview-elements/preview-context';
import { AddItem, Tooltip, Proportion } from 'wix-style-react';
import { composer } from '../../../component-decorators/composer';
export var IconPreviewWrapper = composer()
    .withTranslation()
    .compose(function (props) { return (React.createElement(PreviewMode.Consumer, null, function (value) {
    return value.isPreview && !props.src ? (React.createElement("div", { style: {
            height: props.size,
            width: props.size,
        } },
        React.createElement(Tooltip, { appendTo: "scrollParent", content: props.t('solution.preview.addiconToolTip'), flip: true },
            React.createElement(Proportion, { className: s.iconAvatar },
                React.createElement(AddItem, { onClick: function () { return onClickIconAdd(value.appId); } }))))) : (props.children);
})); });
var onClickIconAdd = function (appId) {
    window.open("https://dev.wix.com/dc3/my-apps/" + appId + "/market/info/basic-info");
};
//# sourceMappingURL=icon-wrapper.js.map